var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-order-table',{attrs:{"accounting-journals-type":_vm.accountingJournalsType,"title":_vm.$t('global.models.order.heading'),"subtitle":_vm.$t('global.models.order.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }